<accordion [isAnimated]="true">
    <accordion-group [isOpen]="true">
        <span accordion-heading>
            <i class="fa fa-money-bill"></i> Monto a Crear
        </span>
        <form [formGroup]="advanceForm">
            <div class="form-group row">
                <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Monto de Anticipo</b>
                    <span appRequiredAsterisk [formGroup]="advanceForm" controlName="amount"></span>
                </label>
                <div class="col-10 col-md-10 col-sm-8 ">
                    <input type="text" mask="separator.2" thousandSeparator="," class="form-control"
                        formControlName="amount"
                        [ngClass]="advanceForm.controls.amount.errors ? 'is-invalid' : 'is-valid'">

                </div>
            </div>
            <div class="form-group row">
                <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Observaciones</b>
                    <span appRequiredAsterisk [formGroup]="advanceForm" controlName="observations"></span>
                </label>
                <div class="col-10 col-md-10 col-sm-8 ">
                    <textarea class="form-control" formControlName="observations" cols="30" rows="10"
                        [ngClass]="advanceForm.controls.observations.errors ? 'is-invalid' : 'is-valid'"></textarea>

                </div>
            </div>
        </form>
    </accordion-group>
</accordion>